export default __webpack_public_path__ + "static/media/school5.1c2b2134.webp";